
<app-timeline-workshop-accepted-defects></app-timeline-workshop-accepted-defects>
<app-timeline-workshop-add-fitter></app-timeline-workshop-add-fitter>
<div class='fullcontainer'>
  <app-workshop-nav></app-workshop-nav>
  <app-timeline-workshop-toolbar></app-timeline-workshop-toolbar>

  <div class='timelineLineContainer'>
    <div class='timelineMainContainer'>
      <app-timeline-workshop-main></app-timeline-workshop-main>
    </div>
  </div>
</div>
